import React from 'react';
import { LogoProps } from './types';

function Message({ width, height, color }: LogoProps) {
  return (
    <svg width={width} height={height} viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0)">
        <path
          d="M13.0645 2.5H1.77422C1.56034 2.5 1.35522 2.5878 1.20398 2.74408C1.05274 2.90036 0.967773 3.11232 0.967773 3.33333V11.6667C0.967773 11.8877 1.05274 12.0996 1.20398 12.2559C1.35522 12.4122 1.56034 12.5 1.77422 12.5H13.0645C13.2784 12.5 13.4836 12.4122 13.6348 12.2559C13.786 12.0996 13.871 11.8877 13.871 11.6667V3.33333C13.871 3.11232 13.786 2.90036 13.6348 2.74408C13.4836 2.5878 13.2784 2.5 13.0645 2.5ZM12.4436 11.6667H2.44358L5.26616 8.65L4.68552 8.07083L1.77422 11.1833V3.96667L6.78632 9.12083C6.93742 9.27604 7.14182 9.36316 7.35487 9.36316C7.56792 9.36316 7.77232 9.27604 7.92342 9.12083L13.0645 3.8375V11.1292L10.0968 8.0625L9.52826 8.65L12.4436 11.6667ZM2.30245 3.33333H12.4113L7.35487 8.52917L2.30245 3.33333Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="14.5161" height="15" fill="transparent" transform="translate(0.161133)" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Message;
